module.exports = __webpack_public_path__ + "img/pantalla-1-8.9ac184b3.png";